import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackEvents } from "../api/analytics";

export function SiteAnalyticsListener() {
  const location = useLocation();
  const lastPath = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      const path = location.pathname;
      if (path === lastPath.current) return;
      lastPath.current = path;
      trackEvents([{ eventType: "page_view", path }]);
    }, 300);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location.pathname]);

  return null;
}
